<!--svg弹窗-->
<template>
  <div class="svgDialog" v-show="isShow">
    <div class="mask"></div>
    <div
      style="width: 100%;height: 100%;display: flex;align-items: center;justify-content: center;z-index: 99;position: fixed;left: 0;top: 0;">
      <div :style="dialogStyle">
        <div class="event-content">
          <p class="titles">
            <span class="t_title">{{svgPath}}</span>
            <img @click.stop='isShow = false' :src="closeImg" class="closeImage" />
          </p>
          <webSvgPlayerDialog :svgpath="realPath" ref="webSvgPlayer" class="webSvgPlayer"
            @widthAndHeight='widthAndHeight'></webSvgPlayerDialog>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import webSvgPlayerDialog from '@/components/module/svg/webSvgPlayerDialog.vue'
  import resourcesStore from '@/cache/resourcesStore.js'
  export default {
    components: {
      webSvgPlayerDialog
    },
    props: {},
    data () {
      return {
        isShow: false,
        realPath: undefined,
        svgPath: '',
        width: '',
        height: ''
      }
    },
    created () {
      debugPage=this
    },
    mounted () {
      debugPage=this
    },
    destroyed () {},
    computed: {
      getBackgroudImageStyle () {
        return resourcesStore.getters.getBackgroudImageStyle
      },
      getBackgroudColorStyle () {
        return resourcesStore.getters.getBackgroudColorStyle
      },
      getResourcesByName () {
        return resourcesStore.getters.getResourcesByName
      },
      getColorById () {
        return resourcesStore.getters.getColorById
      },
      getColorStyleById () {
        return resourcesStore.getters.getColorStyleById
      },
      closeImg () {
        return this.getResourcesByName('wedoButton/close.png')
      },
      dialogStyle () {
        return {
          'z-index': '100',
          'width': +this.width+30+'px',
          'height': +this.height+50+'px',
        }
      }
    },
    watch: {},
    methods: {
      showSvgDialog (svgPath) {
        this.$emit('isLoad',true)
        //移除斜线
        svgPath=svgPath.replace(/\\/g,'')
        this.svgPath=svgPath
        this.realPath=svgPath.split(';')[0]
        setTimeout(() => {
          this.$emit('isLoad',false)
          this.isShow=true
        },3000);
      },
      widthAndHeight (width,height) {
        this.width=width
        this.height=height
      },
    }
  }
</script>

<style scoped>
  .svgDialog {
    position: absolute;
    width: auto;
    height: auto;
  }

  .webSvgPlayer {
    width: 100%;
    height: calc(100% - 40px);
  }

  .mask {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    left: 0;
    top: 0;
    z-index: 99;
  }

  .svgDialog .event-content {
    /*position: fixed;
		top: 5%;
		left: 15%;*/
    margin: auto;
    padding: 0;
    background: white;
    border-radius: .06rem;
    color: black;
    text-align: center;
    padding: 0.1rem;
    height: 100%;
    width: 100%;
    /*z-index: 999;*/
  }

  .closeImage {
    float: right;
    width: .2rem;
    height: .2rem;
    cursor: pointer;
  }

  .titles {
    color: #5C5B61;
    margin-bottom: .1rem;
    font-weight: 1000;
    height: 20px;
  }
</style>